import React, {Component} from 'react';
import axios from "axios";
import * as ROUTES from "../../constants/routes";
import FormGroup from "reactstrap/lib/FormGroup";
import {Alert, FormControl} from "react-bootstrap";
import Label from "reactstrap/es/Label";
import {css} from "@emotion/core";
import { ClockLoader} from "react-spinners";
import {BACKEND_BASE_URL} from "../../constants/routes";


const override = css`
  display: block;
  margin: 0 auto;
  border-color: red;
`;

class Otp extends Component {

    constructor(props) {
        super(props);
        this.state = {...this.INITIAL_STATE}
        if(this.props.user){
            this.props.history.push(ROUTES.HOME);
        }
        this.onSubmit = this.onSubmit.bind(this)
        this.onChange = this.onChange.bind(this)
        this.updateUser= this.updateUser.bind(this)
    }

    INITIAL_STATE = {
        email: '',
        otp: '',
        error: null,
        type:'worker',
        loading:false
    };

    updateUser(user){
        this.props.updateOtpInfo(user)
    }
    onSubmit = event => {
        this.setState({loading:true})

        let url = this.state.type ? 'workerOtp': 'clientOtp'
        const { email, otp } = this.state;
        axios.post(`${BACKEND_BASE_URL}/users/workerOtp`, {
            email: email,
            otp:otp
        }).then(
            res=> {
                this.setState({loading:false})

                console.log(res.data)
                // this.setState({error: res.data.message})
                // reactLocalStorage.setObject('user', res.data);
                // localStorage.setItem("user", res);
                // console.log(super.props.firebase.users)
                // this.props.firebase.users = res
                // this.setState({ ...INITIAL_STATE })
                if(res.data.docId){
                    // localStorage.setItem("userId", {
                    //     docId: res.data.docId,
                    //     type: res.data.type
                    // });
                    let user = {
                        docId: res.data.docId,
                        type: res.data.type
                    }
                    this.updateUser(user)
                    this.props.history.push(ROUTES.PASSWORD_CONFIRM);
                }
                // this.updateUser(res.data.data)
                // this.props.firebase.userListener(res);
                // console.log(this.props)

            }).catch(e=>{
                // this.setState({error: e.message})
            console.log(e.message)
            this.setState({loading:false})

        })


        // this.props.firebase
        //     .doSignInWithEmailAndPassword(email, password)
        //     .then(() => {
        //         this.setState({ ...INITIAL_STATE });
        //         this.props.history.push(ROUTES.HOME);
        //     })
        //     .catch(error => {
        //         this.setState({ error });
        //     });
        event.preventDefault();
    };
    onChange = event => {
        this.setState({ [event.target.name]: event.target.value });
    };
    render() {
        const { email, otp, error } = this.state;
        const isInvalid = otp === '' || email === '';
        return (
            <html lang="en">
            <head>
                <title>Confirm Account Details</title>
                <link rel="icon" type="image/png" href="images/icons/favicon.ico"/>
                <link rel="stylesheet" type="text/css" href="vendor/bootstrap/css/bootstrap.min.css"/>
                <link rel="stylesheet" type="text/css" href="fonts/font-awesome-4.7.0/css/font-awesome.min.css"/>
                <link rel="stylesheet" type="text/css" href="fonts/iconic/css/material-design-iconic-font.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/animate/animate.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/css-hamburgers/hamburgers.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/animsition/css/animsition.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/select2/select2.min.css"/>
                <link rel="stylesheet" type="text/css" href="vendor/daterangepicker/daterangepicker.css"/>
                <link rel="stylesheet" type="text/css" href="css/util.css"/>
                <link rel="stylesheet" type="text/css" href="css/main.css"/>
            </head>
            <body>


            <div className="limiter">
                <div className="container-login100" style={{backgroundImage: "url('images/bgm.jpg')" }}>
                    <div className="wrap-login100">
                        <form className="login100-form validate-form" onSubmit={this.onSubmit}>
					<span className="login100-form-logo">
                        <img src={"images/supwork_logo_dark.svg"} height={50} width={50} className={"zmdi"}/>
                        {/*<i className="zmdi zmdi-landscape"></i>*/}
					</span>

                            <span className="login100-form-title p-b-34 p-t-27">
						Activate Account/Hesabınızı Etkinleştirin
					</span>

                            <h3 className="danger">
                                {error}
                            </h3>

                            <div className="wrap-input100 validate-input" data-validate = "Enter email">
                                <input className="input100" type="text" name="email" value={email} onChange={this.onChange} placeholder="Enter Your Email/E-postanızı giriniz"/>
                                <span className="focus-input100" data-placeholder="&#xf207;"></span>
                            </div>

                            <div className="wrap-input100 validate-input" data-validate="Enter otp">
                                <input className="input100" type="text"     name="otp" value={otp} onChange={this.onChange} placeholder="Input Your One Time Code/ Aktivasyon kodunuzu giriniz"/>
                                <span className="focus-input100" data-placeholder="&#xf191;"></span>
                            </div>


                            {/*<div className="">*/}
                            {/*   <Label for="exampleSelect">Are You A Worker or a Client?</Label>*/}
                            {/*    <select type="select" name="type" id="exampleSelect" onChange={this.onChange} value={this.state.type}>*/}
                            {/*        <option>Worker</option>*/}
                            {/*        <option>Client</option>*/}
                            {/*    </select>*/}
                            {/*</div>*/}





                            <div className="container-login100-form-btn">
                                <button className="login100-form-btn">
                                    Activate/Gonder
                                </button>
                            </div>

                        </form>
                    </div>
                </div>
            </div>


            <div id="dropDownSelect1"></div>

            <script src="vendor/jquery/jquery-3.2.1.min.js"></script>
            <script src="vendor/animsition/js/animsition.min.js"></script>
            <script src="vendor/bootstrap/js/popper.js"></script>
            <script src="vendor/bootstrap/js/bootstrap.min.js"></script>
            <script src="vendor/select2/select2.min.js"></script>
            <script src="vendor/daterangepicker/moment.min.js"></script>
            <script src="vendor/daterangepicker/daterangepicker.js"></script>
            <script src="vendor/countdowntime/countdowntime.js"></script>
            <script src="js/main.js"></script>

            </body>
            </html>


        );
    }
}

export default Otp;